module.exports = __webpack_public_path__ + "static/media/site-connecte.af5ae320.glb";